export default function FinancialServices({ fill }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3_886)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.375 17.5C17.4875 17.5 20 16.25 20 14.375V2.5C20 1.25 17.5 0 14.375 0C11.25 0 8.75 1.25 8.75 2.5V6.875C10.2125 7.4875 11.4625 8.5125 12.35 9.8125C12.9625 9.9325 13.6375 9.99875 14.375 9.99875C16.0125 9.99875 17.375 9.6725 18.35 9.14125C18.4884 9.06517 18.6232 8.98258 18.7537 8.89375V10.6187C18.7537 10.9125 18.52 11.3687 17.7513 11.7887C17.0063 12.195 15.8638 12.4937 14.3763 12.4937C14.0788 12.4937 13.7954 12.4825 13.5262 12.46C13.6263 12.8708 13.6929 13.2917 13.7262 13.7225C13.9371 13.7342 14.1538 13.74 14.3763 13.74C16.0138 13.74 17.3762 13.4137 18.3512 12.8825C18.4897 12.8064 18.6244 12.7238 18.755 12.635V14.36C18.755 14.655 18.5688 15.0925 17.7663 15.525C16.9763 15.95 15.7913 16.235 14.3788 16.235C14.0913 16.235 13.8129 16.2233 13.5437 16.2C13.4477 16.6155 13.3185 17.0226 13.1575 17.4175C13.5508 17.4617 13.9575 17.4838 14.3775 17.4838L14.375 17.5ZM17.75 8.05C18.5188 7.63 18.7525 7.17375 18.7525 6.88V5.155C18.6233 5.24333 18.4887 5.32583 18.3488 5.4025C17.3763 5.93375 16.0112 6.26 14.3737 6.26C12.7362 6.26 11.3738 5.93375 10.3988 5.4025C10.2603 5.32642 10.1256 5.24383 9.995 5.155V6.88C9.995 7.17375 10.2288 7.63 10.9975 8.04875C11.7425 8.455 12.885 8.75375 14.3725 8.75375C15.86 8.75375 16.9975 8.455 17.7475 8.04875L17.75 8.05ZM10 3.125C10 2.765 10.1562 2.41875 10.4475 2.2075C10.6062 2.0925 10.7788 1.9775 10.915 1.915C11.2563 1.7575 12.965 1.24875 14.3775 1.24875C15.79 1.24875 17.015 1.5325 17.84 1.915C17.995 1.98625 18.1663 2.0975 18.3175 2.2075C18.6063 2.41625 18.755 2.76 18.755 3.11625V3.12375C18.755 3.4175 18.5212 3.87375 17.7525 4.29375C17.0075 4.7 15.865 4.99875 14.3775 4.99875C12.89 4.99875 11.7525 4.69875 11.0025 4.29375C10.2338 3.875 10 3.4175 10 3.125Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.25 14.375C11.25 17.4875 8.7375 20 5.625 20C2.5125 20 0 17.4875 0 14.375C0 11.2625 2.5125 8.75 5.625 8.75C8.7375 8.75 11.25 11.2625 11.25 14.375ZM10 14.375C10 16.7875 8.0375 18.75 5.625 18.75C3.2125 18.75 1.25 16.7875 1.25 14.375C1.25 11.9625 3.2125 10 5.625 10C8.0375 10 10 11.9625 10 14.375Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_3_886">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
